
import jsSHA from 'jssha'
import template from 'url-template'
import xhr from '../services/XHR.coffee'

XHR = new xhr()

deleteItem = (context, commit_type, item) ->
  new Promise (resolve, reject) ->
    try
      await XHR.delete(item)
      context.commit
        type: commit_type
        payload: item
      resolve true
    catch e
      console.log e.response
      reject e

updateItem = (context, commit_type, item) ->
  new Promise (resolve, reject) ->
    try
      context.commit
        type: commit_type
        payload: await XHR.put(item)
      resolve true
    catch e
      console.log e.response
      reject e

addItem = (context, commit_type, resource_url, item) ->
  new Promise (resolve, reject) ->
    try
      context.commit
        type: commit_type
        payload: await XHR.post(context.getters.resourceURL(resource_url), item)
      resolve true
    catch e
      console.log e.response
      reject e

updateCollection = (context, commit_type, collection) ->
  new Promise (resolve, reject) ->
    promises = collection.map (item) ->
      try
        await XHR.put item
      catch e
        console.log e.response

    Promise.all(promises)
      .then ()->
        context.commit
          type: commit_type
          payload: collection
        resolve true
      .catch (e) ->
        reject e

## Singeltons
#

class CollectionSingelton
  @promise = null

  @fetch: (context, resource_url, commit_type) ->
    @promise ?= new Promise (resolve, reject) =>
      try
        context.commit
          type: commit_type
          payload: await XHR.get(context.getters.resourceURL(resource_url))
        resolve true
      catch e
        console.log e
        reject e
    @promise

class ClientsSingelton
  @fetch: (context, resource_url, commit_type) ->
    @promise = new Promise (resolve, reject) =>
      try
        context.commit
          type: commit_type
          payload: await XHR.get(context.getters.resourceURL(resource_url))
        resolve true
      catch e
        console.log e
        reject e
    @promise

class GroupsSingelton extends CollectionSingelton

class ConfigsSingelton extends CollectionSingelton

class ActivityTypesSingelton extends CollectionSingelton

class ServiceSingelton
  promise = null

  @fetch: (context) ->
    promise ?= new Promise (resolve, reject) =>
      try
        context.commit
          type: 'SET_RESOURCES'
          resources: await XHR.get('/api/')
        resolve true
      catch e
        console.log e
        reject e
    promise

export default
  xhrIsLoading: (context, status) ->
    context.commit
      type: 'XHR_IS_LOADING'
      xhr_is_loading: status

  showDialog: (context, dialog) ->
    context.commit
      type: 'SHOW_DIALOG'
      dialog: dialog

  working: (context, status) ->
    context.commit
      type: 'WORKING'
      xhr_is_loading: status

  getServices: (context) ->
    ServiceSingelton.fetch(context)

  getConfigs: (context) ->
    ConfigsSingelton.fetch(context, 'config.list', 'SET_CONFIGS')

  getGroups: (context) ->
    GroupsSingelton.fetch(context, 'client_property_group.list', 'SET_CPROP_GROUPS')

  getActivityTypes: (context) ->
    ActivityTypesSingelton.fetch(context, 'activity_type.list', 'SET_ACTIVITY_TYPES')

  getActivities: (context, filter) ->
    new Promise (resolve, reject) =>
      try
        context.commit
          type: 'SET_ACTIVITIES'
          payload: await XHR.get(context.getters.resourceURL('activity.list'), filter)
        resolve true
      catch e
        console.log e
        reject e

  ###### ADD
  addGroup: (context, evt) ->
    addItem context, 'ADD_CPROP_GROUP', 'client_property_groups.post', evt

  addProperty: (context, evt) ->
    addItem context, 'ADD_CPROP', 'client_property_definitions.post', evt

  addOption: (context, evt) ->
    addItem context, 'ADD_OPTION', 'client_property_options.post', evt

  addActivity: (context, evt) ->
    addItem context, 'ADD_ACTIVITY', 'activity.post', evt

  addActivityType: (context, evt) ->
    addItem context, 'ADD_ACTIVITY_TYPE', 'activity_type.post', evt

  ###### UPDATE

  updateActivity: (context, activity) ->
    if 'activity_type_label' of activity then delete activity.activity_type_label
    updateItem context, 'UPDATE_ACTIVITY', activity

  updateActivityType: (context, type) ->
    updateItem context, 'UPDATE_ACTIVITY_TYPE', type

  updateConfig: (context, config) ->
    updateItem context, 'UPDATE_CONFIG', config

  updateGroup: (context, group) ->
    updateItem context, 'UPDATE_CPROP_GROUP', group

  updateOption: (context, option) ->
    updateItem context, 'UPDATE_OPTION', option

  updateProperty: (context, prop) ->
    updateItem context, 'UPDATE_CPROP', prop

  ###### DELETE
  deleteActivity: (context, evt) ->
    deleteItem context, 'DELETE_ACTIVITY', evt

  deleteGroup: (context, evt) ->
    deleteItem context, 'DELETE_CPROP_GROUP', evt

  deleteProperty: (context, evt) ->
    deleteItem context, 'DELETE_CPROP', evt

  deleteOption: (context, evt) ->
    deleteItem context, 'DELETE_OPTION', evt

  deleteActivityType: (context, type) ->
    new Promise (resolve, reject) ->
      try
        await XHR.delete(type)
        context.commit
          type: 'DELETE_ACTIVITY_TYPE'
          activity_type: type
        resolve true
      catch e
        console.log e.response
        reject e


  ###### UPDATE COLLECTIONS

  updateGroups: (context, e) ->
    new Promise (resolve, reject) ->
      promises = e.groups.map (g) ->
        try
          await XHR.put g
        catch e
          console.log e.response

      Promise.all(promises)
        .then ()->
          context.commit
            type: 'UPDATE_GROUPS'
            groups: e.groups
          resolve true
        .catch (e) ->
          reject e


  updateProps: (context, e) ->
    new Promise (resolve, reject) ->
      promises = e.props.map (p) ->
        try
          await XHR.put p
        catch e
          console.log e.response

      Promise.all(promises)
        .then ()->
          context.commit
            type: 'UPDATE_PROPS'
            group: e.group
            props: e.props
          resolve true
        .catch (e) ->
          reject e

  updateOptions: (context, e) ->
    new Promise (resolve, reject) ->
      promises = e.options.map (o) ->
        try
          await XHR.put(o)
        catch e
          console.log e.response

      Promise.all(promises)
        .then ()->
          context.commit
            type: 'UPDATE_OPTIONS'
            group: e.group
            props: e.prop
            options: e.options
          resolve true
        .catch (e) ->
          reject e

  updateActivityTypes: (context, e) ->
    new Promise (resolve, reject) ->
      promises = e.types.map (g) ->
        try
          await XHR.put g
        catch e
          console.log e.response

      Promise.all(promises)
        .then ()->
          context.commit
            type: 'UPDATE_ACTIVITY_TYPES'
            types: e.types
          resolve true
        .catch (e) ->
          reject e

  ###### CLIENT

  getClientList: (context) ->
    ClientsSingelton.fetch(context, 'client.list', 'SET_CLIENT_LIST')

  checkClientId: (context, mutation) ->
    new Promise (resolve, reject) ->
      if mutation.id != null
        try
          result = await XHR.get(context.getters.resourceURL('client.list'), {id: mutation.id} )
          clients = result.getEmbeds('clients')
          resolve (clients.length == 0) or (mutation.uid == clients[0].uid)
        catch e
          console.log e
          reject e
      else
        resolve true

  selectClient: (context, client) ->
    new Promise (resolve, reject) ->
      try
        context.commit
          type: 'SELECT_CLIENT'
          selected_client: await XHR.get(client.getLink('self').href)
          resolve true
      catch e
        console.log e.response
        reject e

  setClientNote: (context, note) ->
    console.log note
    context.commit
      type: 'SET_CLIENT_NOTE'
      note: note

  newClient: (context, mutation) ->
    context.commit 'NEW_CLIENT'

  saveClient: (context, mutation) ->
    [client, original_prop_values] = mutation

    new Promise (resolve, reject) ->

      is_existing_client = client.getLink('self')?

      if is_existing_client
        try
          await XHR.put(client)
          context.dispatch 'getClientList'
          context.commit
            type: 'SELECT_CLIENT'
            selected_client: client

          properties = client.getEmbeds('client_property')
          promises = properties.map (p) ->
            if p.value != original_prop_values[p.property_uid]
              console.log p
              try
                await XHR.put p
              catch e
                console.log e.response
                reject e
          Promise.all(promises)
            .then () ->
              context.dispatch 'getClientList'
              resolve true
            .catch (e) ->
              reject e
        catch e
          console.log e
          reject e

      else # is new client
        try
          properties = client.getEmbeds('client_property')
          client = await XHR.post(context.getters.resourceURL('client.post'), client)
          promises = properties.map (p) ->
            p.client_uid = client.uid
            try
              p = await XHR.post(context.getters.resourceURL('client_property.post'), p)
              client.addEmbed('client_property', p)
            catch e
              console.log e.response
              reject e

          Promise.all(promises)
            .then ->
              context.commit
                type: 'SELECT_CLIENT'
                selected_client: client
              context.dispatch 'getClientList'
              resolve true
        catch e
          console.log e.response
          reject e

  login: (context, user) ->
    new Promise (resolve, reject) ->
      shaObj = new jsSHA 'SHA-512', 'TEXT'
      shaObj.update user.password
      password_hash = shaObj.getHash 'HEX'

      XHR.setUser user.username, password_hash

      try
        user = await XHR.get(context.getters.resourceURL('user.login'))

        user.password = password_hash
        user.is_logged_in = true

        context.commit
          type: 'UPDATE_USER'
          user: user

        resolve true
      catch e
        console.log e.response
        context.commit
          type: 'RESET_USER'
        XHR.setUser null, null
        throw e

  refresh_login: (context, user) ->
    XHR.setUser user.username, user.password

  logout: (context) ->
    XHR.setUser null, null
    context.commit
      type: 'RESET_USER'



// WEBPACK FOOTER //
// ./src/vuex/actions.coffee